import React from "react";
import {
  AntdLayout,
  AntdHeader,
  AntdContent,
  AntdFooter,
} from "../components/Base/BaseLayout";
import { Header } from "../components/Header";
import { BottomNavigation } from "../components/BottomNavigation";
import { DownloadAppBar } from "../components/DownloadAppBar";
import { PullToRefresh } from "../components/Base/PullToRefresh";
import { LayoutProps } from "./Layout.types";
import { useNavigation, ROUTES } from "../utils/navigation";
import "./Layout.scss";
import { useGlobalValue } from "../stores";
import { env } from "../config/env";

export const Layout: React.FC<LayoutProps> = ({
  children,
  className = "",
  variant = "primary",
  testId,
  cannotRefresh,
}) => {
  const { navigate, getCurrentPath } = useNavigation();
  const [downloadAppBarVisible] = useGlobalValue("downloadAppBarVisible", true);
  const handleBottomNavClick = (itemId: string) => {
    // 添加标记表示这次导航是从底部导航条触发的
    const navigationState = { fromBottomNav: true };

    switch (itemId) {
      case "home":
        navigate(ROUTES.HOME, { state: navigationState });
        break;
      case "vip":
        navigate(ROUTES.VIP, { state: navigationState });
        break;
      case "event":
        navigate(ROUTES.EVENT_CENTER, { state: navigationState });
        break;
      case "profile":
        navigate(ROUTES.PROFILE, { state: navigationState });
        break;
      case "agent-center":
        // goToAgentCenter(undefined, { state: navigationState });
        if (env.INVITE_PAGE_VERSION !== "new") {
          navigate(ROUTES.AGENT_CENTER, { state: navigationState });
        } else {
          navigate(ROUTES.INVITE_FRIENDS, { state: navigationState });
        }
        break;
      default:
        console.log("Unknown navigation item:", itemId);
    }
  };

  // 根据当前路径确定活跃的导航项
  const getActiveItem = () => {
    const currentPath = getCurrentPath();
    if (currentPath === ROUTES.EVENT_CENTER) return "event";
    if (currentPath === ROUTES.VIP) return "vip";
    if (currentPath === ROUTES.HOME || currentPath === ROUTES.HOME_ALT)
      return "home";
    // if (currentPath === ROUTES.AGENT_CENTER) return "agent-center";
    if (currentPath === ROUTES.INVITE_FRIENDS) return "agent-center";
    if (currentPath === ROUTES.PROFILE) return "profile";
    return "get-cash"; // 默认
  };

  // 判断是否显示Header（只在首页显示）
  const shouldShowHeader = () => {
    const currentPath = getCurrentPath();
    return currentPath === ROUTES.HOME || currentPath === ROUTES.HOME_ALT;
  };

  // 下拉刷新处理函数
  const handleRefresh = async () => {
    window.location.reload();
  };

  return (
    <AntdLayout
      id="gbRoot"
      className={`mobile-layout layout-optimized ${className}`}
      variant={variant}
      testId={testId}
    >
      {shouldShowHeader() && (
        <>
          {/* 手机端状态栏区域 */}
          <div className="mobile-status-bar" />
          <AntdHeader className="mobile-layout__header" variant={variant}>
            {downloadAppBarVisible && <DownloadAppBar />}
            <Header />
          </AntdHeader>
        </>
      )}

      <AntdContent
        className="mobile-layout__content"
        style={!shouldShowHeader() ? { marginTop: "0px" } : undefined}
      >
        <PullToRefresh onRefresh={handleRefresh} canRefresh={!cannotRefresh}>
          {children}
        </PullToRefresh>
      </AntdContent>

      <AntdFooter className="mobile-layout__footer" variant={variant}>
        <BottomNavigation
          activeItem={getActiveItem()}
          onItemClick={handleBottomNavClick}
        />
      </AntdFooter>
    </AntdLayout>
  );
};

export default Layout;
